import { memo } from 'react'
import Image from 'next/image'
import { Container, Typography } from '@cleartrip/ct-design-components'
import {
  EARNED_LOYALTY_ASSET_LOGO,
  EARNED_LOYALTY_PROMO_BANNER_COPY,
  EARNED_LOYALTY_PROMO_BANNER_COPY_MINIMAL,
  EARNED_LOYALTY_PROMO_BANNER_COPY_MINIMAL_SUBTEXT,
  ELITE_MEMBERSHIP_CHANGE_DATE_FEE,
} from '@/constants/components/eliteMembership'

import styles from './EarnedLoyaltyPromoBanner.module.scss'

export type EarnedLoyaltyPromoBannerVariant = 'default' | 'minimal'

type Props = {
  variant?: EarnedLoyaltyPromoBannerVariant
  changeDateFee?: number
}

function EarnedLoyaltyPromoBanner(props: Props) {
  const { variant = 'default', changeDateFee = ELITE_MEMBERSHIP_CHANGE_DATE_FEE } = props
  const isMinimal = variant === 'minimal'

  const eliteImage = (
    <Image
      src={EARNED_LOYALTY_ASSET_LOGO}
      alt=""
      width={50}
      height={20}
      style={
        isMinimal
          ? { display: 'block', height: '20px', width: '32px' }
          : { display: 'block', width: '48px', height: '20px' }
      }
      aria-hidden
      draggable={false}
      unoptimized
    />
  )

  return (
    <Container
      role="region"
      aria-label="Elite offer"
      borderRadius="12px"
      padding={isMinimal ? '0px' : '12px'}
      className={`o-hidden ${isMinimal ? '' : styles.root}`}
    >
      <Container className="flex flex-middle" style={{ gap: '12px' }}>
        <Container className="flex flex-middle flex-no-shrink">
          {isMinimal ? (
            <Container className={`px-2 py-1 ${styles.eliteLogoPill}`} aria-hidden>
              {eliteImage}
            </Container>
          ) : (
            eliteImage
          )}
        </Container>
        <Container className="flex flex-column flex-1">
          <Typography
            style={{ textWrap: 'auto' }}
            variant={isMinimal ? 'HM4' : 'B2'}
            componentNode="span"
            colorCode={isMinimal ? 'black' : 'white'}
            className="m-0"
          >
            {isMinimal
              ? EARNED_LOYALTY_PROMO_BANNER_COPY_MINIMAL(changeDateFee)
              : EARNED_LOYALTY_PROMO_BANNER_COPY(changeDateFee)}
          </Typography>
          {isMinimal && (
            <Typography variant="B3" componentNode="span" className="m-0">
              {EARNED_LOYALTY_PROMO_BANNER_COPY_MINIMAL_SUBTEXT}
            </Typography>
          )}
        </Container>
      </Container>
    </Container>
  )
}

export default memo(EarnedLoyaltyPromoBanner)
